<template>
	<div>
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item>能耗分析</el-breadcrumb-item>
			<el-breadcrumb-item>分级分项统计</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search" @submit.native.prevent>
			<el-form-item label="搜索：">
				<el-popover v-model="visible">
					<el-input ref="deptInput" class="cp" readonly slot="reference" autosize size="small" value="" placeholder="选择部门/集中器"
					 v-model="getJZ"></el-input>
					<div >
						<el-tree v-loading="treeLoad" :data="treeDate" :expand-on-click-node="false" :highlight-current="true"
						 @node-click="handleNodeClick" :props="jzProps" accordion node-key='id'>
							<span class="custom-tree-node" slot-scope="{ node, data }">
								<span>
									<i v-if="!data.parentId && !data.isJz" class="el-icon-office-building"></i>
									<i v-if="data.parentId" class="el-icon-location-outline"></i>
									<i v-if="data.isJz" class="el-icon-coin"></i>
									{{ data.departmentName }}
								</span>
							</span>
						</el-tree>
					</div>
				</el-popover>
			</el-form-item>
			<el-form-item>
			  <el-select size="small" v-model="formInline.dateType"  style="width: 120px;" @change="getDateType">
			    <el-option
			      v-for="item in dateList"
			      :key="item.value"
			      :label="item.label"
			      :value="item.value">
			    </el-option>
			  </el-select>
			</el-form-item>
      <el-form-item  v-if="formInline.dateType == 'day'">
         <el-date-picker
            @change="getDay"
            type="daterange"

            size="small"
            value-format="yyyy-MM-dd"
            v-model="dayStr"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            >
         </el-date-picker>
      </el-form-item>
      <el-form-item>
         <el-date-picker
            style="width: 120px;"
            @change="getData"
            v-if="formInline.dateType == 'month'"
            size="small"
            value-format="yyyy-MM"
            v-model="formInline.monthDate"
            type="month"
            placeholder="选择月">
         </el-date-picker>
         <el-date-picker
            style="width: 120px;"
            @change="getData"
            v-if="formInline.dateType == 'year'"
            size="small"
            value-format="yyyy"
            v-model="formInline.yearDate"
            type="year"
            placeholder="选择年">
         </el-date-picker>
      </el-form-item>


		</el-form>

		<!--列表-->
		<el-table size="small" :data="dataList" highlight-current-row v-loading="loading" :header-cell-style="this.$store.state.headerCss"
		 border element-loading-text="拼命加载中" style="width: 100%;"  :row-class-name="tableRowClassName">
			<el-table-column align="center" type="index" width="60">
			</el-table-column>

			<el-table-column prop="objname" label="用能单位" width="260"  >

			</el-table-column>

      <el-table-column v-for="item in tableCol" :key="item.id" :label="item.energytypename+'('+ item.unit +')'"  align="center">
        <el-table-column v-for="sitem in item.energyuseList" :key="sitem.id" :label="sitem.name" :prop="sitem.prop" min-width="120"  >
        </el-table-column>
      </el-table-column>


		</el-table>
	</div>
</template>

<script>
	import { GetEnergySumList } from '../../api/analysisMG'
  import {getDepartmentTerminalInfoLis,getTerminalInfoByDepId} from '../../api/energyMG'
	export default {
		data(){
			return{
				loading:false,
        visible:false,
				formInline:{
					yearDate:"",
					monthDate:"",
					startDate:"",
					endDate:"",
					terId:"",
          departmentId:"",
					dateType:"day",
				},
        dayStr:[],
        getJZ:"",
				dataList :[],
        tableCol:[],
        treeLoad:false,
        treeDate:[],
        jzProps: {
        	label: "departmentName",
        	children: 'deps'
        },
        dateList:[
          { value:'day',label:'自定义' },
          { value:'month',label:'月' },
          { value:'year',label:'年' },
        ],
        user:{}
			}
		},
		created(){
      let d = new Date()
      this.formInline.startDate = d.getFullYear()+ '-'+( d.getMonth()+1 < 10 ? '0':'' ) +  (d.getMonth()+1) + '-' + '01'
      this.formInline.endDate = d.getFullYear()+ '-'+( d.getMonth()+1 < 10 ? '0':'' ) + (d.getMonth()+1) + '-' + ( d.getDate() < 10 ? '0':'' ) + d.getDate()
      this.dayStr = [ this.formInline.startDate,this.formInline.endDate ]
      this.user = JSON.parse(sessionStorage.getItem('userdata'))
      this.getJZ = this.user.departmentName



      this.getJzData()

		},
		methods:{
			search(){

			},


      getDateType(e){

        if(e == 'day'){
          let d = new Date()
          this.formInline.startDate = d.getFullYear()+ '-'+( d.getMonth()+1 < 10 ? '0':'' ) +  (d.getMonth()+1) + '-' + '01'
          this.formInline.endDate = d.getFullYear()+ '-'+( d.getMonth()+1 < 10 ? '0':'' ) + (d.getMonth()+1) + '-' + ( d.getDate() < 10 ? '0':'' ) + d.getDate()
          this.formInline.monthDate = ''
          this.formInline.yearDate = ''

        }else if( e == 'month'){
            let dateStr = new Date().getFullYear() + '-'+( new Date().getMonth()+1 < 10 ? '0':'' ) +  (new Date().getMonth()+1)
            this.formInline.monthDate = dateStr
            this.formInline.yearDate = ''
            this.formInline.startDate = ''
            this.formInline.endDate = ''

        }else{
           this.formInline.yearDate =  (new Date().getFullYear())+''
           this.formInline.startDate = ''
           this.formInline.endDate = ''
           this.formInline.monthDate = ''
        }

        this.getData()
      },
      getDay(e){
        this.formInline.startDate = e[0]
        this.formInline.endDate = e[1]
        this.getData()
      },
			getData(){
        this.loading = true
				GetEnergySumList(this.formInline).then(res => {
          this.loading = false
					if( res.status == 1 ){

            if(JSON.stringify(res.data.dataList[0]) == "{}"){
               this.dataList = []
            }else{
               this.dataList = res.data.dataList
            }

            this.tableCol = res.data.energytypeuseList
          }
				})
			},
      //获取集中器信息
      getJzData: function() {
      	return new Promise((resolve, reject) => {
      		getDepartmentTerminalInfoLis().then(res => {
      			this.treeLoad = false
      			if (res.status == 1) {
      				this.treeDate = this.changeData(res.data.menuDepList)
              this.getTepIds(this.user.departmentId)
      			} else {
      				this.$message.error(res.msg)
      			}
      		})
      	})

      },
      changeData(data) {
      	data.forEach(item => {
      		if (item.terminalInfo) {
      			if (!item.deps) {
      				item.deps = []
      			}
      			item.terminalInfo.forEach(sitem => {
      				let obj = {}
      				obj.id = sitem.id
      				obj.departmentName = sitem.terminalName
      				obj.terminalCode = sitem.terminalCode
      				obj.isJz = true
      				item.deps.push(obj)
      			})
      		}
      		if (item.deps) {
      			this.changeData(item.deps)
      		}
      	})
      	return data
      },
      handleNodeClick(data) {
      	this.getJZ = data.departmentName
      	if (data.isJz) {
          this.formInline.terId = data.id
          this.formInline.departmentId = ""
      	} else {
           this.formInline.terId = ""
      		this.formInline.departmentId = data.id
      	}
        this.getData()
        this.visible = false

      },


      getTepIds(id){
        // 点击部门获得集中器id
        getTerminalInfoByDepId({
        	depId: id
        }).then(res => {
        	if (res.status == 1) {

        		this.getData()
        	} else {
        		this.$message.error(res.msg)
        	}
        })
      },
      rowClass(){
        return "color:#5c5c5c;background:#fff"
      },
      tableRowClassName({row,rowIndex}){

        if(row.objname == '合计'){
          console.log(row.objname)
          return 'total-row'
        }
      }


		}
	}
</script>

<style >
  .el-table .total-row {
      background: #f0f9eb;
    }
</style>



// WEBPACK FOOTER //
// src/views/analysis/categoryStatistics.vue